import axios from 'axios'
import { BUSCAR_MAPAS_VEICULOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarMapasVeiculos (filtros, pagina, registrosPorPagina) {
  let url = `${URL}/mapas-veiculos/buscar?size=${registrosPorPagina}&from=${pagina}`;
  if (filtros.modelo) {
    url = `${url}&modelo=${filtros.modelo}`
  }
  if (filtros.tipoVeiculo) {
    url = `${url}&tipoVeiculo=${filtros.tipoVeiculo}`
  }
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_MAPAS_VEICULOS,
        payload: response

      })
  );
}
